export default "__VITE_ASSET__665aab5e__"